import { inject, Service } from '@angular/core';
import { SnackbarService } from 'ok-angular-shared/components';

@Service()
export class ClipboardUtility {
  private snackbarService = inject(SnackbarService);

  public async copy(value: string | null) {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      this.snackbarService.success('Kopieret til udklipsholder');
    } catch {
      this.snackbarService.error('Kunne ikke kopiere til udklipsholder');
    }
  }
}
